import { render } from "./Jogviszony.vue?vue&type=template&id=22745b43"
import script from "./Jogviszony.vue?vue&type=script&lang=js"
export * from "./Jogviszony.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__